import * as Actions from '../../actions';

const initialState = { data: null };

const userSettingsReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_USER_SETTINGS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default userSettingsReducer;
